import React from 'react';
import './DisableAppBackground.scss';

export default function DisableAppBackground(props) {
  return (
    <div id="disable-app-background" className="disable-app-background"/>
  );
}



// WEBPACK FOOTER //
// ./src/components/DisableAppBackground/index.js